import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

// v-calendar v3 defaults its global component prefix to "V" (<VDatePicker>), not the "Vc" prefix v2
// used (<vc-date-picker>, still the tag name in Datepicker.vue/DatepickerLegacy.vue). Restoring the v2
// prefix here avoids a template rename. Client-only: both consumers already wrap their usage in
// <ClientOnly>, so the components are never resolved during SSR.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VCalendar, { componentPrefix: 'Vc' })
})
